import {Api, apiUrls} from "../../helpers/api";
import http from "./httpService";
import {UserModel, UserPasswordsModel} from "../../administration/models/user";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../models/httpError";

export class AuthService {
    public static async authenticatedUser(): Promise<UserModel> {
        const response = await http.get<UserModel>(Api.getUrl(apiUrls.user.authenticatedUser));
        return response?.data;
    }

    public static async changePassword(data: UserPasswordsModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.patch(Api.getUrl(apiUrls.user.password), data);
    }
}
